// Cache utility for API responses and static data
const CACHE_VERSION = 'v1';
const CACHE_NAME = `iqleap-cache-${CACHE_VERSION}`;

// Cache duration in milliseconds (24 hours)
const CACHE_DURATION = 24 * 60 * 60 * 1000;

export const cacheData = async (key, data) => {
  try {
    const cacheItem = {
      data,
      timestamp: Date.now()
    };
    localStorage.setItem(`${CACHE_NAME}-${key}`, JSON.stringify(cacheItem));
  } catch (error) {
    console.warn('Cache storage failed:', error);
  }
};

export const getCachedData = async (key) => {
  try {
    const cached = localStorage.getItem(`${CACHE_NAME}-${key}`);
    if (!cached) return null;

    const cacheItem = JSON.parse(cached);
    const age = Date.now() - cacheItem.timestamp;

    if (age > CACHE_DURATION) {
      localStorage.removeItem(`${CACHE_NAME}-${key}`);
      return null;
    }

    return cacheItem.data;
  } catch (error) {
    console.warn('Cache retrieval failed:', error);
    return null;
  }
};

export const clearCache = () => {
  try {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(CACHE_NAME)) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    console.warn('Cache clear failed:', error);
  }
};

// Fetch with cache
export const fetchWithCache = async (url, options = {}) => {
  const cacheKey = `fetch-${url}`;
  
  // Try to get from cache first
  const cached = await getCachedData(cacheKey);
  if (cached) {
    return cached;
  }

  // Fetch from network
  try {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    
    const data = await response.json();
    
    // Cache the response
    await cacheData(cacheKey, data);
    
    return data;
  } catch (error) {
    console.error('Fetch failed:', error);
    throw error;
  }
};

